import { useMemo } from "react";
import UtilizationReportCard from "./UtilizationReportCard";
import { computeGrandTotals } from "./utilizationReportUtils";

const UtilizationReportCards = ({ reportData }) => {
  const cards = reportData?.cards ?? [];

  const grandTotalRow = useMemo(
    () => computeGrandTotals(cards),
    [cards]
  );

  if (!cards.length) {
    return (
      <div className="utilization-cards__empty">
        No utilization report data available.
      </div>
    );
  }

  return (
    <div className="utilization-cards">
      {grandTotalRow && (
        <UtilizationReportCard
          card={{ id: "grand-total", title: "Grand Total", rows: [] }}
          meta={reportData.meta}
          variant="grand"
          totalRow={grandTotalRow}
        />
      )}
      {cards.map((card) => (
        <UtilizationReportCard
          key={card.id}
          card={card}
          meta={reportData.meta}
        />
      ))}
    </div>
  );
};

export default UtilizationReportCards;
